import { FunctionComponent } from "react";
import "./OrdinalIndicator.css";

interface OrdinalIndicatorProps {
  ordinal: number;
}

const OrdinalIndicator: FunctionComponent<OrdinalIndicatorProps> = ({
  ordinal,
}) => {
  return <div className="ordinal-indicator-component">{ordinal}</div>;
};

export { OrdinalIndicator };
